import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './authContext';
import { AppDialogProvider } from './components/AppDialogProvider';
import { CurrentUserProvider } from './currentUserContext';
import reportWebVitals from './reportWebVitals';

// Frontend bootstrap: her mountes hele React-applikationen i den ene root-node.
const root = ReactDOM.createRoot(document.getElementById('root'));
const appTree = (
  <AuthProvider>
    <CurrentUserProvider>
      <AppDialogProvider>
        <App />
      </AppDialogProvider>
    </CurrentUserProvider>
  </AuthProvider>
);

root.render(process.env.NODE_ENV === 'production'
  ? <React.StrictMode>{appTree}</React.StrictMode>
  : appTree);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
